<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M3.19,802.5l-2.45-2.45l1.08-0.29l-0.65-2.43c-0.23,0.03-0.46,0.05-0.68,0.05c-0.04,0-0.07,0-0.11,0l0.92-1.91l1.77,1.19
	c-0.26,0.16-0.54,0.3-0.84,0.41l0.65,2.41l1.2-0.32L3.19,802.5L3.19,802.5z M-4.67,801.46l0-3.47l0.97,0.56l1.26-2.18
	c-0.21-0.16-0.41-0.34-0.59-0.53l2.09-0.69l0.38,2.1c-0.33-0.07-0.64-0.18-0.94-0.32l-1.25,2.16l1.07,0.62L-4.67,801.46
	L-4.67,801.46z M6,797.68l0.56-0.97l-2.18-1.26c-0.16,0.21-0.33,0.41-0.53,0.59l-0.67-2.01l2.06-0.37c-0.07,0.3-0.17,0.58-0.3,0.86
	l2.16,1.25l0.62-1.07l1.74,2.98L6,797.68L6,797.68z M-6.16,796.07l-3.34-0.88l2.45-2.45l0.29,1.08l2.43-0.65
	c-0.04-0.28-0.05-0.56-0.04-0.84l1.99,0.96l-1.25,1.81c-0.17-0.27-0.31-0.56-0.43-0.86l-2.42,0.65L-6.16,796.07L-6.16,796.07z
	 M5.38,792.67l-1.89-0.94l1.18-1.76c0.13,0.22,0.25,0.45,0.35,0.69l2.42-0.65l-0.29-1.08l3.35,0.9l-2.46,2.43l-0.32-1.2l-2.41,0.65
	C5.37,792.03,5.39,792.35,5.38,792.67L5.38,792.67z M-4.25,791.4c0.06-0.27,0.15-0.53,0.25-0.79l-2.18-1.26l-0.56,0.97l-1.73-3
	l3.45,0.02l-0.62,1.07l2.17,1.25c0.19-0.27,0.42-0.53,0.67-0.75l0.72,2.07L-4.25,791.4L-4.25,791.4z M2.05,789.9l-0.38-2.13
	c0.25,0.06,0.49,0.14,0.72,0.24l1.26-2.18l-0.97-0.56l3-1.73l-0.02,3.46l-1.07-0.62l-1.25,2.16c0.27,0.19,0.52,0.41,0.75,0.66
	L2.05,789.9L2.05,789.9z M-0.2,789.59l-1.84-1.26c0.22-0.14,0.46-0.26,0.71-0.36l-0.65-2.42l-1.08,0.29l0.9-3.35l2.43,2.46
	l-1.2,0.32l0.65,2.41c0.35-0.06,0.69-0.08,1.03-0.06L-0.2,789.59L-0.2,789.59z"/>
</svg>

</template>